import { PRINCIPAL_ACCOUNT } from "../helpers/account";

class TagService {
  static sendEvent(event) {
    const { category, action, label } = event;

    if (typeof window.o_link === 'function' && window.o_view !== undefined) {
      window.o_link(category, action, label);
    }
  }

  static sendPageView(trackObj, nonInteraction = false) {
    if (typeof window.o_view === 'function' && window.o_view !== undefined) {
      /**
       * Fonction permettant d'appeler un pageview sur les différents outils d'analytics en passant par le TMS.
       * @param {Object.<string>} trackObj objet contenant des informations concernant la page en cours
       * @param {bool} [nonInteraction] default false, utiliser ce paramètre en cas d'affichage automatique de popin pour ne pas fausser les taux de rebonds !
       */
      window.o_view(trackObj, nonInteraction);
    }
  }

  /**
   * Get app use case depending on user or service
   *
   * @param {Object} ctx app context
   * @returns the LOST use case to send in page view tracking object, default 'na'
   */
  static getAppUseCase(ctx) {
    if (
      ctx.identities.accountLevel === PRINCIPAL_ACCOUNT
      && ctx.identities.isPro
      && ctx.identities.isFirstConnection
    ) {
      return 'parcours_1ere_connexion_pro';
    }
    if (ctx.serviceConf.dictionary === 'recovery') {
      return 'recovery';
    }
    return 'na';
  }
}

export default TagService;
